import React from 'react';
import { Flex } from 'antd';

import DiagnosticsStepItem, { StepDefinition } from './DiagnosticsStepItem';

type DiagnosticsStepperProps = {
  steps: ReadonlyArray<StepDefinition>;
  completedKeys: string[];
};

export default function DiagnosticsStepper({ steps, completedKeys }: DiagnosticsStepperProps) {
  const completedSet = new Set(completedKeys);

  return (
    <Flex align="flex-start" style={{ width: '100%' }}>
      {steps.map((step, index) => (
        <DiagnosticsStepItem
          key={step.key}
          step={step}
          isCompleted={completedSet.has(step.key)}
          isPrevCompleted={index > 0 && completedSet.has(steps[index - 1].key)}
          isFirst={index === 0}
          isLast={index === steps.length - 1}
        />
      ))}
    </Flex>
  );
}
